<template>
    <v-container>
        <v-layout wrap justify-center>
            <v-flex xs12 xl8 pa-4>
                <rating-placeholder v-if="loading"></rating-placeholder>
                <v-fade-transition>
                    <div v-show="!loading">

                        <div v-if="notFound" class="text-center mt-4">
                            <content-not-found></content-not-found>
                        </div>

                        <div v-else>
                            <v-flex xs12>
                                <w-main-title title="Calificación a Proveedor" :breadcrumbs="breadcrumbs"></w-main-title>
                            </v-flex>

                            <div v-if="rating">
                                <rating-feed :rating="rating"></rating-feed>
                                <user-comment-control :rating-id="rating.id"></user-comment-control>
                                <rating-replies :rating-id="rating.id"></rating-replies>
                            </div>
                        </div>

                    </div>
                </v-fade-transition>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>

    import WMainTitle from '@/components/common/WMainTitle'
    import ContentNotFound from '@/components/common/ContentNotFound'

    import {debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'

    import RatingPlaceholder from '@/components/ratings/RatingPlaceholder'
    import ProviderStats from '@/components/providers/ProviderStats'
    import RatingFeed from '@/components/ratings/RatingFeed'
    import RatingReplies from '@/components/ratings/RatingReplies'
    import UserCommentControl from '@/components/ratings/UserCommentControl'

    import {mapState, mapMutations} from 'vuex'

    export default{
        components: {
            WMainTitle,
            ContentNotFound,
            RatingPlaceholder,
            ProviderStats,
            RatingFeed,
            RatingReplies,
            UserCommentControl,
        },
        mounted(){
            var vm = this
            vm.getRating()
        },
        computed:{
            providerBreadcrumb(){

                if(!this.rating || !this.rating.service_provider) return null

                var provider = this.rating.service_provider.institution || this.rating.service_provider.user
                var providerName = provider.name || `${provider.first_name} ${provider.last_name[0]}.`
                var providerLink = `/providers/${this.rating.service_provider.id}/profile`

                return {
                    text: providerName,
                    disabled: false,
                    to: providerLink
                }

            },
            breadcrumbs(){

                if(!this.providerBreadcrumb) {
                    return [
                        {
                            text: 'Proveedores',
                            disabled: false,
                            to: `/specialists`
                        },
                        {
                            text: 'Calificación',
                            disabled: true,
                            href: ''
                        },
                    ]
                }

                return [
                    {
                        text: 'Proveedores',
                        disabled: false,
                        to: `/specialists`
                    },
                    this.providerBreadcrumb,
                    {
                        text: 'Calificación',
                        disabled: true,
                        href: ''
                    },
                ]
            }
        },
        data(){
            return {
                rating: null,
                loading: true,
                notFound: false
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),

            async getRating(){
                var vm = this
                vm.notFound = false
                var id = vm.$route.params.id
                vm.loading = true
                const response = await ApiUtils.makeGet(`public/providers/rating/${id}`)
                vm.loading = false

                if(!response.ok){
                    if(response.status != 404){
                        vm.showSnackBar('Ha ocurrido un error consultando calificación')
                    }else{
                        vm.rating = null
                        vm.notFound = true
                    }
                    return
                }

                const json = await response.json()
                vm.rating = json.result.rating

            }
        }
    }
</script>

<style scoped>
    .content-wrapper{
        margin-top: 100px;
    }

    .cover-container{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
    }
</style>
